import conditionNodes from "../data/conditionNodesJson.json"

const STOPWORDS = new Set([
  "a", "an", "the", "of", "to", "in", "on", "at", "for", "and", "or",
  "test", "tests", "sign",
])

export const normalizeToSlug = (label) => {
  if (!label) return ""
  return label
    .toString()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
}

const tokenize = (label) =>
  normalizeToSlug(label)
    .split("-")
    .filter((t) => t.length > 1 && !STOPWORDS.has(t))

const jaccard = (a, b) => {
  if (!a.length || !b.length) return 0
  const setA = new Set(a)
  const setB = new Set(b)
  let intersection = 0
  setA.forEach((t) => {
    if (setB.has(t)) intersection += 1
  })
  const union = setA.size + setB.size - intersection
  return union === 0 ? 0 : intersection / union
}

let testIndex = null
const buildTestIndex = () => {
  if (testIndex) return testIndex
  const index = []
  const walk = (node) => {
    const tests = node?.data?.tests
    if (Array.isArray(tests)) {
      tests.forEach((t) => {
        if (t?.id && t?.label) {
          index.push({
            conditionNodesId: t.id,
            label: t.label,
            tokens: tokenize(t.label),
          })
        }
      })
    }
    if (Array.isArray(node?.children)) node.children.forEach(walk)
  }
  if (Array.isArray(conditionNodes)) conditionNodes.forEach(walk)
  testIndex = index
  return index
}

export const fuzzyMatchTestLabel = (label, { limit = 3, minScore = 0.25 } = {}) => {
  const queryTokens = tokenize(label)
  if (!queryTokens.length) return []
  const index = buildTestIndex()
  const scored = index
    .map((entry) => ({ ...entry, score: jaccard(queryTokens, entry.tokens) }))
    .filter((e) => e.score >= minScore)
    .sort((a, b) => b.score - a.score)
  return scored.slice(0, limit)
}

export const findExactTestByLabel = (label) => {
  const slug = normalizeToSlug(label)
  if (!slug) return null
  const index = buildTestIndex()
  return index.find((e) => normalizeToSlug(e.label) === slug) || null
}

export const buildAdHocTestKey = (label) => normalizeToSlug(label)
